import axios from 'axios';

export const getShipFroms = async () => {
  const response = await axios.get('/seller/shipfrom');
  return response?.data ?? [];
};

export const deleteShipFrom = async (shipFromId) => {
  const response = await axios.delete(`/seller/shipfrom/${shipFromId}`);
  return response?.data ?? [];
};
